import React, { useState, useEffect, useRef } from 'react';
import { changeSidebarVisibility } from '../slices/layouts/thunk';
import { useSelector, useDispatch } from "react-redux";
import { createSelector } from 'reselect';
import "../STYLE/Header.css";
import { SESSION_REMOVE_ITEM } from 'Components/constants/enums';
import { useNavigate } from 'react-router-dom';
import { ADMIN_HEAD, CHANGE_PASS_FUNC, LOGOUT_FUNC } from 'Components/constants/commonNames';

const Header = ({ onChangeLayoutMode, layoutModeType, headerClass }: any) => {
    const dispatch: any = useDispatch();
    const navigate = useNavigate();

    const [dropdownOpen, setDropdownOpen] = useState(false);
    const dropdownRef = useRef<HTMLDivElement>(null); 

    const selectDashboardData = createSelector(
        (state: any) => state.Layout.sidebarVisibilitytype,
        (sidebarVisibilitytype) => sidebarVisibilitytype
    );
    
    const sidebarVisibilitytype = useSelector(selectDashboardData);

    const handleLogout = () => {
        SESSION_REMOVE_ITEM();
        navigate("/login");
    };

    const handleChangePassword = () => {
        navigate("/change-password");
    };

    const toggleDropdown = () => {
        setDropdownOpen((prev) => !prev);
    };

    const closeDropdown = (event: MouseEvent) => {
        if (dropdownRef.current && !dropdownRef.current.contains(event.target as Node)) {
            setDropdownOpen(false);
        }
    };

    useEffect(() => {
        document.addEventListener('mousedown', closeDropdown);
        return () => {
            document.removeEventListener('mousedown', closeDropdown);
        };
    }, []);

    const toogleMenuBtn = () => {
        const windowSize = document.documentElement.clientWidth;
        const humberIcon = document.querySelector(".hamburger-icon") as HTMLElement;
        dispatch(changeSidebarVisibility("show"));

        if (windowSize > 767) humberIcon.classList.toggle('open');

        if (document.documentElement.getAttribute('data-layout') === "horizontal") {
            document.body.classList.toggle("menu");
        }

        if (sidebarVisibilitytype === "show" && (document.documentElement.getAttribute('data-layout') === "vertical" || document.documentElement.getAttribute('data-layout') === "semibox")) {
            if (windowSize < 1025 && windowSize > 767) {
                document.body.classList.remove('vertical-sidebar-enable');
                document.documentElement.setAttribute('data-sidebar-size', document.documentElement.getAttribute('data-sidebar-size') === 'sm' ? '' : 'sm');
            } else if (windowSize > 1025) {
                document.body.classList.remove('vertical-sidebar-enable');
                document.documentElement.setAttribute('data-sidebar-size', document.documentElement.getAttribute('data-sidebar-size') === 'lg' ? 'sm' : 'lg');
            } else if (windowSize <= 767) {
                document.body.classList.add('vertical-sidebar-enable');
                document.documentElement.setAttribute('data-sidebar-size', 'lg');
            }
        }

        if (document.documentElement.getAttribute('data-layout') === "twocolumn") {
            document.body.classList.toggle('twocolumn-panel');
        }
    };

    return (
        <React.Fragment>
            <header id="page-topbar" className={headerClass}>
                <div className="layout-width">
                    <div className="navbar-header">
                        <div className="d-flex">
                            <button
                                onClick={toogleMenuBtn}
                                type="button"
                                className="btn btn-sm px-3 fs-16 header-item vertical-menu-btn topnav-hamburger shadow-none"
                                id="topnav-hamburger-icon">
                                <span className="hamburger-icon">
                                    <span></span>
                                    <span></span>
                                    <span></span>
                                </span>
                            </button>
                        </div>

                        <div className="dropdown" ref={dropdownRef}>
                            <button
                                onClick={toggleDropdown}
                                className="btn btn-icon btn-ghost ms-2 darvajobtn"
                                id="dropdownMenuButton"
                            >
                                <i className="mdi mdi-account bg-light py-1 px-2 rounded-circle"></i>
                                <p>{ADMIN_HEAD}</p>
                            </button>
                            {dropdownOpen && (
                                <div className="dropdown-menu show">
                                    <button className="dropdown-item" onClick={handleChangePassword}>
                                        <i className="mdi mdi-key"></i>
                                        {CHANGE_PASS_FUNC}
                                    </button>
                                    <button className="dropdown-item" onClick={handleLogout}>
                                        <i className="mdi mdi-logout"></i>
                                        {LOGOUT_FUNC}
                                    </button>
                                </div>
                            )}
                        </div>
                    </div>
                </div>
            </header>
        </React.Fragment>
    );
};

export default Header;
